{/* <html>

<head>
  <meta charset="utf-8" />
  <style>
    .pydocx-caps {
      text-transform: uppercase
    }

    .pydocx-center {
      text-align: center
    }

    .pydocx-comment {
      color: blue
    }

    .pydocx-delete {
      color: red;
      text-decoration: line-through
    }

    .pydocx-hidden {
      visibility: hidden
    }

    .pydocx-insert {
      color: green
    }

    .pydocx-left {
      text-align: left
    }

    .pydocx-list-style-type-cardinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimal {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedCircle {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedFullstop {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedParen {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalZero {
      list-style-type: decimal-leading-zero
    }

    .pydocx-list-style-type-lowerLetter {
      list-style-type: lower-alpha
    }

    .pydocx-list-style-type-lowerRoman {
      list-style-type: lower-roman
    }

    .pydocx-list-style-type-none {
      list-style-type: none
    }

    .pydocx-list-style-type-ordinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-upperLetter {
      list-style-type: upper-alpha
    }

    .pydocx-list-style-type-upperRoman {
      list-style-type: upper-roman
    }

    .pydocx-right {
      text-align: right
    }

    .pydocx-small-caps {
      font-variant: small-caps
    }

    .pydocx-strike {
      text-decoration: line-through
    }

    .pydocx-tab {
      display: inline-block;
      width: 4em
    }

    .pydocx-underline {
      text-decoration: underline
    }

    body {
      margin: 0px auto;
      width: 51.00em
    }
  </style>
</head>

<body> */}
let termsES=  `  
  <p>
    <strong>ALERTA DE FRAUDE AL CONSUMIDOR: PROTEJASE. TENGA CUIDADO CUANDO UN EXTRAÑO LE PIDE QUE ENVÍE DINERO, ESPECIALMENTE PARA
      SUBASTAS A INTERNET, PERIÓDICOS O OFERTAS TELEFÓNICAS</strong>. Barri no garantiza la entrega o la idoneidad de los
    bienes o servicios pagados a través de nuestros Servicios. Barri no es un proveedor de servicios de custodia. El Cliente
    y el Beneficiario acuerdan no utilizar los Servicios para fines de depósito en garantía.</p>
  <p>Notifique a Barri inmediatamente si cree que su nombre de usuario y contraseña de Barri se han perdido o han sido robados
    o si alguien pudo usarlos sin su permiso.</p>
  <ol class="pydocx-list-style-type-decimal">
    <li>
      <strong>LOS SERVICIOS DE BARRI MONEY TRANSFER ("SERVICIOS") SON PROPORCIONADOS POR BARRI MONEY SERVICES, LLC ("BARRI") Y ESTÁN
      SUJETOS A ESTOS TÉRMINOS Y CONDICIONES ("ACUERDO") Y LEY APLICABLE</strong>. Se puede obtener información adicional sobre los
      Servicios en
      <a href="http://www.barri.com">www.barri.com</a> dependiendo de los servicios que elija. La disponibilidad 
      del servicio y los fondos depende de ciertos factores, incluido el Servicio seleccionado, la 
      selección de opciones de entrega retrasada, cantidad enviada, país de destino, disponibilidad 
      de divisas, cuestiones reglamentarias, cuestiones de protección del consumidor, requisitos de 
      identificación, restricciones de entrega, horas de ubicación del agente y diferencias en el tiempo 
      zonas (colectivamente, "Restricciones"). El destinatario designado ("Beneficiario") generalmente 
      puede recibir fondos enviados por el consumidor de Barri ("Usted") en las ubicaciones del Agente 
      en la Ubicación del Pago Esperado. Para las transacciones enviadas dentro de los EE. UU., la 
      ubicación de pago esperado generalmente significa cualquier ubicación del agente en el estado 
      de destino o en el territorio de EE. UU. que usted identifique. Para las transacciones enviadas 
      fuera de EE. UU., la ubicación de pago esperada generalmente significa cualquier ubicación del 
      agente en el país de destino que usted identifique. Puede pagar los Servicios utilizando una 
      tarjeta de crédito Visa o MasterCard emitida en EE. UU. o una tarjeta de débito emitida por o a 
      través de una institución financiera ubicada en los EE. UU. ("Tarjeta bancaria").
      Alternativamente, puede pagar en efectivo en una sucursal de Barri o utilizando el teléfono 
      celular de Barri o las opciones de ACH ("Opciones de pago alternativas"). El total debido es 
      pagadero antes de que Barri procese la transacción. Si Barri no recibe autorización del emisor 
      de la Tarjeta bancaria (o del proveedor de su cuenta, en el caso de las Opciones de pago 
      alternativas), la transacción no se procesará y los fondos no se transmitirán al Beneficiario. Cada 
      vez que utiliza su tarjeta bancaria u opciones de pago alternativas para pagar los servicios, 
      acepta que Barri está autorizado a cargar su tarjeta bancaria designada o cuenta aplicable por 
      el total que se le haya divulgado en relación con la transacción. El beneficiario normalmente 
      recibirá los fondos enviados por usted en efectivo, cheque o una combinación de los mismos; 
      con algunos Servicios, los fondos pueden acreditarse a un banco, prepago o tarjeta de crédito, 
      o una cuenta similar. El beneficiario puede elegir un método de pago que difiera del método de 
      pago que especifique; usted autoriza a Barri a respetar el método de pago elegido por el 
      Beneficiario. Los beneficiarios que optan por recibir fondos a través de un método de pago 
      distinto al efectivo o en una moneda distinta a la que seleccionó pueden incurrir en tarifas 
      adicionales para acceder a los fondos. Ciertos países y / o jurisdicciones pueden imponer un 
      impuesto, tarifa y / o tarifa sobre su transacción y / o el recibo del Beneficiario o el acceso a los 
      fondos transferidos. Actas:
      <ol class="pydocx-list-style-type-lowerRoman">
        <li>que exceden ciertas cantidades;</li>
        <li>a ciertos destinos;</li>
        <li>implican ciertos asuntos regulatorios o problemas de protección del consumidor; o</li>
        <li>enviado a través de opciones demoradas puede tomar más tiempo, estar sujeto a límites en dólares o estar sujeto a
          Restricciones adicionales.</li>
      </ol>
    </li>
  </ol>
  <p>
    Las transacciones pueden ser informadas a las autoridades correspondientes. Los servicios de 
    mensajería y notificación pueden incurrir en tarifas adicionales. En algunos destinos, se le puede 
    solicitar al beneficiario que proporcione una identificación para recibir fondos en efectivo. Barri confía en la información que nos proporciona para enviar dinero. Por favor, revise todos los detalles de la 
    transacción para verificar su precisión antes de completar su transacción.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">2.<strong> CARGO DE ADMINISTRACIÓN:</strong> Las transacciones no recogidas o canceladas por usted dentro 
    de un año de la fecha de envío serán evaluadas con un cargo de administración no reembolsable de 
    hasta cincuenta centavos por mes a partir de la fecha de envío, que no excederá cuarenta y dos 
    dólares, que se deducirá de la cantidad enviada (o cuando dicho cargo exceda la cantidad máxima 
    permitida por la ley, la cantidad máxima permitida por la ley).</span>
  </p>
  <p>
    <span style="margin-left:3.00em">3.<strong> REEMBOLSOS:</strong> Sujeto a la ley aplicable: (i) las transferencias pueden cancelarse para un 
    reembolso del monto del capital, a menos que los fondos se hayan retirado o depositado en el 
    momento en que Barri reciba su solicitud por escrito; (ii) para ciertos servicios, excluyendo el pago de 
    facturas y los productos y servicios prepagos de Barri, Barri puede proporcionar un reembolso de 
    tarifa de transferencia si los fondos no están disponibles dentro del plazo especificado; y (iii) Barri 
    puede cobrarle una tarifa para reembolsarle el monto del capital en aquellos casos en que el 
    Beneficiario rechace sus fondos. Los reembolsos que califican para transferencias que comienzan y 
    terminan en los Estados Unidos se realizarán dentro de los 45 días posteriores a la recepción de su 
    solicitud válida por escrito. Barri puede emitir su reembolso a través de una transferencia de dinero 
    Barri o Barri puede emitir el reembolso a la tarjeta de crédito o débito que se utilizó para pagar la 
    transacción. En lugar de recibir el reembolso mediante la transferencia de dinero de Barri, puede 
    solicitar a Barri que le envíe un cheque por correo por el monto del reembolso. Cuando lo exija la ley, 
    los reembolsos asociados con ciertas transferencias internacionales pueden ser elegibles para un 
    tratamiento diferente.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">4.<strong> TÉRMINOS ESPECIALES PARA TRANSFERENCIAS INTERNACIONALES:</strong> Sin perjuicio de lo 
    anterior, y sujeto a la ley aplicable, las transferencias internacionales pueden cancelarse para un 
    reembolso total del capital y los honorarios pagados dentro de los 30 minutos del pago, a menos que 
    los fondos hayan sido recogidos o depositados. También puede recibir un reembolso completo en 
    ciertas circunstancias si declara con éxito un error o según lo estipula la ley aplicable.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">5.<strong> ARBITRAJE Y RENUNCIA A RECURSOS COLECTIVOS Y JUICIO POR JURADO:</strong> A MENOS 
    QUE LA LEY APLICABLE EXIJA LO CONTRARIO, CUALQUIER CONTROVERSIA O RECLAMO 
    QUE SURJA DE O ESTÉ RELACIONADO CON UNA TRANSFERENCIA, EL ACUERDO O 
    INCUMPLIMIENTO DE ESTE ACUERDO, INCLUYENDO CADA RECLAMO ESTATUTARIO DEL 
    CONSUMIDOR, ”), SERÁ RESUELTO EXCLUSIVAMENTE POR ARBITRAJE ADMINISTRADO POR 
    LA AMERICAN ARBITRATION ASSOCIATION (" AAA ") BAJO SUS REGLAS DE ARBITRAJE 
    COMERCIAL Y, EN CASO APROPIADO, LOS PROCEDIMIENTOS SUPLEMENTARIOS DE LA AAA 
    PARA DISPUTAS RELACIONADAS CON EL CONSUMIDOR (" AAA "), ÁREAS DE CONSUMO 
    DISPONIBLE EN EL SITIO WEB DE AAA EN <a href="http://WWW.ADR.ORG">WWW.ADR.ORG</a> USTED ENTIENDE QUE AUSENTE 
    DE ESTA SECCIÓN, TENDRÍA DERECHO A DEMANDAR ANTE LA CORTE Y A TENER UN JUICIO 
    CON JURADO.
    </span>
  </p>
  <p>
      <span style="margin-left:3.00em"> LA DETERMINACIÓN DE SI UNA DISPUTA ESTÁ SUJETA A ARBITRAJE, EN CASO DE 
      CONTROVERSIA, SE REGIRÁ POR LA LEY FEDERAL DE ARBITRAJE Y SERÁ DETERMINADA 
      POR UN TRIBUNAL Y NO POR UN ÁRBITRO. SUS HONORARIOS DE ARBITRAJE Y SU 
      PARTICIPACIÓN DE COMPENSACIÓN DE ÁRBITRO SE REGIRÁN POR LAS REGLAS DE LA AAA 
      Y, EN CASO APROPIADO, LIMITADAS POR LAS REGLAS DE CONSUMIDOR DE LA AAA. SI EL 
      ÁRBITRO DETERMINA DICHOS COSTOS COMO EXCESIVOS, PAGAREMOS TODOS LOS 
      HONORARIOS Y GASTOS DEL ARBITRAJE. EL ARBITRAJE SE PUEDE REALIZAR EN 
      PERSONA, MEDIANTE LA ENVÍO DE DOCUMENTOS, POR TELÉFONO O EN LÍNEA, A SU 
      ELECCIÓN, SUJETO A LA DETERMINACIÓN DEL ÁRBITRO. SI ESTÁ EN PERSONA, CUALQUIER 
      AUDIENCIA DE ARBITRAJE A LA QUE ASISTE SE REALIZARÁ EN EL DISTRITO JUDICIAL 
      FEDERAL DE SU RESIDENCIA.
      </span>
  <p/>
  <p>
      <span style="margin-left:3.00em"><strong>RESTRICCIONES.</strong> USTED Y NOSOTROS ACEPTAMOS QUE CUALQUIER ARBITRAJE SE 
      LIMITARÁ A LA DISPUTA ENTRE USTED Y NOSOTROS INDIVIDUALMENTE. EN LA MEDIDA 
      TOTAL PERMITIDA POR LA LEY, (1) NINGÚN ARBITRAJE SERÁ UNIDO CON NINGÚN OTRO; (2) 
      NO HAY DERECHO O AUTORIDAD PARA QUE CUALQUIER DISPUTA SEA ARBITRADA SOBRE 
      UNA BASE DE ACCIÓN COLECTIVA O UTILIZAR PROCEDIMIENTOS DE ACCIÓN COLECTIVA; Y (3) NO HAY DERECHO O AUTORIDAD PARA QUE CUALQUIER DISPUTA SE LLEVE EN UNA 
      CAPACIDAD DE REPRESENTANTE SUPUESTA EN NOMBRE DEL PÚBLICO EN GENERAL O DE 
      CUALQUIER OTRA PERSONA. CUALQUIER DISPUTA DEBE INICIARSE DENTRO DE UN AÑO 
      DESPUÉS DE QUE LA PARTE RECLAMANTE DESCUBRA LOS HECHOS QUE FORMAN LA BASE 
      DE LA CONTROVERSIA O RECLAMO, O SE RENUNCIA PARA SIEMPRE.
      </span>
  <p/>
  <p>
      <span style="margin-left:3.00em"><strong>Excepciones al arbitraje.</strong> Usted y nosotros acordamos que las siguientes Disputas (y solo estas 
        Disputas) no están sujetas a las disposiciones anteriores sobre arbitraje vinculante y pueden 
        presentarse en cualquier tribunal que tenga jurisdicción sobre las partes y el tema: (1) cualquier 
        demanda para obligar a arbitraje, suspensión procedimiento pendiente de arbitraje, o para confirmar, 
        modificar, anular o dictar sentencia sobre el laudo dictado por el árbitro; y (2) cualquier demanda para 
        buscar una medida cautelar temporal que permanecerá vigente solo hasta que un árbitro pueda 
        determinar si la medida debe continuar, modificarse o eliminarse.
      </span>
  <p/>
  <p>
      <span style="margin-left:3.00em"><strong>Divisibilidad.</strong> Usted y nosotros acordamos que si alguna parte de esta Sección se considera ilegal o 
      inaplicable, esa parte se cortará y el resto de la Sección tendrá plena vigencia y efecto.
      </span>
  <p/>
  <p>
    <span style="margin-left:3.00em">6.<strong> LIMITACIONES DE RESPONSABILIDAD:</strong> EXCEPTO QUE SE INDIQUE DE OTRO MODO EN 
    ESTE ACUERDO DE USUARIO O SEA PROVISTO POR LA LEY APLICABLE, EN NINGÚN CASO 
    BARRI, SUS PROVEEDORES, VENDEDORES, PROVEEDORES DE SERVICIOS, COMPAÑÍAS DE 
    SERVICIOS O SUS RESPECTIVOS SUBSIDIARIOS, DIRECTORES, FUNCIONARIOS, AGENTES 
    , LOS SOCIOS, EMPLEADOS O CONSULTORES SERÁN RESPONSABLES DE CUALQUIER 
    DAÑO DIRECTO, INDIRECTO, INCIDENTAL, ESPECIAL, CONSECUENTE O EJEMPLAR, 
    INCLUYENDO, PERO NO LIMITADO A, DAÑOS POR PÉRDIDA DE BENEFICIOS, BUENA 
    VOLUNTAD, USO, DATOS U OTRAS PÉRDIDAS INTANGIBLES (INCLUSO INFORMADO DE LA 
    POSIBILIDAD DE DICHOS DAÑOS) RESULTANTES DE LA NEGLIGENCIA POR PARTE DE 
    BARRI, SUS PROVEEDORES, VENDEDORES, PROVEEDORES DE SERVICIOS, COMPAÑÍAS DE 
    SERVICIOS O SUS RESPECTIVAS SUBSIDIARIAS, AFILIADAS, FUNCIONARIOS, DIRECTORES, 
    AGENTES, SOCIOS O EMPLEADOS.
    </span>
  </p>
  <p>
    <span style="margin-left:3.00em"> <strong>No obstante lo anterior:</strong>
    </span>
  <p/>
  <p>
    <span style="margin-left:3.00em"><strong>Residentes de California:</strong> lo anterior no se aplica a reclamos bajo la Sección 2102 del Código 
    Financiero de California que surjan de Transacciones que se originan en California.</span>
  </p>


  <p>
    <span style="margin-left:3.00em">7.<strong> INTERCAMBIO DE MONEDA, SERVICIOS INTERNACIONALES:</strong> Además de las tarifas de 
    transferencia aplicables a esta transacción, se aplicará un tipo de cambio. La moneda de los Estados 
    Unidos se convierte a moneda extranjera a un tipo de cambio establecido por Barri a menos que las 
    leyes de la Ubicación de pago prevista no permitan que Barri establezca un tipo de cambio. Cualquier 
    diferencia entre la tarifa que se le otorgue y la tasa recibida por Barri será mantenida por Barri (y sus 
    Agentes en algunos casos) además de las tarifas de transferencia. Sujeto a la ley aplicable, la tasa 
    de cambio real o estimada aplicable a su transacción se le proporcionará en las divulgaciones por 
    escrito provistas por Barri en relación con su transacción. Los pagos generalmente se realizarán en 
    la moneda nacional de la ubicación de pago esperado ("moneda local"). En algunos países, puede 
    designar una moneda de pago distinta de la Moneda local; sin embargo, la moneda alternativa que 
    elija puede no estar disponible en todas las ubicaciones del agente. Barri no es responsable del tipo 
    de cambio de moneda que se aplicará si el Beneficiario elige recibir una moneda que no sea la que 
    seleccionó.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">8.<strong> VERIFICACIÓN DE IDENTIDAD Y UBICACIÓN:</strong> AUTORIZA A BARRI A SOLICITAR A SU 
    EMPRESA MÓVIL A QUE USE LOS DETALLES DEL SUSCRIPTOR MÓVIL PARA VERIFICAR SU 
    IDENTIDAD. DICHOS DETALLES PUEDEN INCLUIR EL NOMBRE, LA DIRECCIÓN DE 
    FACTURACIÓN, EL CORREO ELECTRÓNICO Y EL NÚMERO DE TELÉFONO. ESTA 
    INFORMACIÓN TAMBIÉN PUEDE INCLUIR INFORMACIÓN DE LA UBICACIÓN, SI ESTÁ 
    DISPONIBLE.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">9.<strong> USANDO UNA CUENTA:</strong> Donde esté disponible, Barri puede permitirle enviar dinero desde o hacia 
    un banco, una tarjeta prepaga o de crédito, un emisor de la factura o una cuenta similar 
    (colectivamente, "Cuentas"). El banco u otro proveedor de una Cuenta (el "Proveedor de la cuenta") 
    puede imponer tarifas adicionales en una Cuenta. El acuerdo con el Proveedor de la Cuenta rige el 
    uso de una Cuenta y proporciona los derechos y obligaciones del titular de una Cuenta. A menos que lo exija la ley aplicable, Barri no acepta ninguna responsabilidad para usted ni para ningún titular de 
    la cuenta por las tarifas impuestas por un proveedor de la cuenta. Si la moneda que selecciona para 
    una transacción no es la moneda en la que está denominada una Cuenta, el proveedor de la Cuenta 
    puede convertir los fondos a su propio tipo de cambio o rechazar la transferencia. Los Servicios de la 
    cuenta son solo para uso personal o individual y no para el uso de ninguna empresa o entidad legal. 
    Barri puede usar la red de Automated Clearing House ("ACH"), transferencia de libros, transferencia 
    electrónica de fondos, transferencia bancaria u otros métodos para procesar transacciones 
    relacionadas con una Cuenta. Barri no es responsable de las medidas tomadas por el Proveedor de 
    la cuenta, como publicar una transacción de manera incorrecta</span>
  </p>
  <ol class="pydocx-list-style-type-upperLetter">
      <li><strong>AVISO IMPORTANTE PARA EL USO DE CUENTAS:</strong> ASEGÚRESE DE QUE EL NÚMERO DE 
      CUENTA, LOS DETALLES DEL PROVEEDOR DE LA CUENTA Y LA MONEDA 
      SELECCIONADA ESTEN CORRECTAS ANTES DE ENVIAR SU DINERO. SI EL NÚMERO DE 
      LA CUENTA O LOS DETALLES DEL PROVEEDOR DE LA CUENTA SON INCORRECTAS, EL 
      DINERO PUEDE SER DEBITADO O ACREDITADO A LA CUENTA INCORRECTA Y PUEDE 
      NO SER RECUPERADO.
      <br/>
      <span>Barri confia en la información que usted brinda y puede depender únicamente de los números 
      de cuenta y números de identificación que usted proporciona para identificar una cuenta y / o 
      proveedor de cuenta, independientemente de si también proporciona el nombre del titular de la 
      cuenta o el nombre de la cuenta. Proveedor de cuenta.
      </span>
    </li>
    <br/>
    <li><strong>TRANSFERENCIAS A CUENTAS:</strong> el acuerdo del Beneficiario con el Proveedor de Cuenta rige 
    los derechos, responsabilidades y honorarios del Beneficiario (incluidas las tarifas para transferir 
    dinero de una Cuenta), y el Proveedor de Cuenta puede imponer sus propias restricciones con 
    respecto a la disponibilidad de fondos, límites que pueden transferirse a o retenido en una 
    Cuenta, horas de operación, vacaciones u otras limitaciones. En la mayoría de los casos, el 
    Beneficiario debe estar inscrito en el programa de Cuenta para recibir dicha transferencia. Un 
    Beneficiario que no está inscripto en el programa de la Cuenta puede recibir fondos en la 
    ubicación de un Agente y puede estar sujeto a requisitos adicionales. Barri puede ganar dinero 
    con las tarifas asociadas con el uso de Cuentas.
    </li>
    <br/>
    <li><strong>TRANSFERENCIAS DE CUENTAS:</strong> Al iniciar una transacción desde una Cuenta (una 
      "Transacción financiada por la cuenta"), usted (i) afirma que es el propietario de la Cuenta y
      tiene autoridad para iniciar la transacción y (ii) autoriza a Barri a iniciar una transacción 
      electrónica, débitos y créditos a su Cuenta para procesar y corregir errores o si una transacción 
      no puede completarse. Por ley, Barri puede ser responsable por los daños causados por no 
      cargar su Cuenta de acuerdo con estos términos y condiciones, en la cantidad correcta o de 
      manera oportuna, cuando así lo haya instruido usted propiamente. Sin embargo, Barri no será 
      responsable cuando: (1) no tenga suficiente dinero disponible en su cuenta; (2) Su cuenta está 
      cerrada o los retiros restringidos; (3) la transacción excede las limitaciones de dólar o frecuencia 
      impuestas por Barri o su Proveedor de cuenta; (4) circunstancias fuera del control de Barri (como 
      inundaciones, incendios, cortes de energía, fallas mecánicas o del sistema); (5) Su Proveedor 
      de cuenta no honra a una transacción, la transacción no se procesa o la transacción es devuelta 
      por su Proveedor de cuenta; (6) Sus instrucciones se pierden o retrasan en la transmisión a 
      Barri; (7) Barri no procesa su transacción debido a una inquietud de seguridad razonable o la 
      opción del Servicio ha sido descontinuada o suspendida, o Barri le informa de otra manera que 
      su solicitud no será procesada; y (8) otras excepciones permitidas por la ley.</li>
  </ol>
  <p>
    <span style="margin-left:3.00em">10.<strong> USO DEL SITIO WEB DE BARRI, DISPOSITIVO MÓVIL Y SERVICIOS DE TABLETA</strong></span>
  </p>
  <ol class="pydocx-list-style-type-upperLetter">
    <li><strong>SERVICIOS BASADOS EN LA UBICACIÓN:</strong> Usted reconoce y autoriza que la información 
    relativa a la ubicación de su dispositivo móvil se pueda usar para evaluar la ubicación. La 
    ubicación se puede obtener en cualquier momento mientras esté conectado a este sitio web. La 
    información de ubicación no será revelada a otros. Usted acepta expresamente que autoriza a 
    Barri a recopilar y utilizar su ubicación como parte del sitio web de Barri y la elegibilidad para el 
    uso del sitio web.
    </li>
    <br/>
    <li><strong>PROPIEDAD INTELECTUAL:</strong> El sitio web de Barri, sitios y aplicaciones de dispositivos móviles 
    y tabletas (colectivamente, el "Sitio web"), el Servicio, el contenido y toda la propiedad intelectual (incluidos, entre otros, autores, patentes, derechos de bases de datos, marcas comerciales y 
    marcas de servicio) son propiedad de Barri o de terceros, y todos los derechos, títulos e intereses 
    de los mismos y de los mismos seguirán siendo propiedad de Barri y / o de dichos terceros. El 
    sitio web y el servicio se pueden usar solo para el propósito permitido por estos Términos y 
    condiciones. Puede ver y conservar una copia de las páginas del sitio web solo para su uso 
    personal y no comercial. No puede duplicar, publicar, modificar, crear trabajos derivados de, 
    participar en la transferencia de, publicar en la World Wide Web, o de ninguna manera distribuir 
    o explotar el sitio web, el Servicio o cualquier parte del mismo para cualquier uso público o 
    comercial sin el consentimiento expreso por escrito de Barri. No deberá (i) utilizar ningún robot, 
    araña, raspador u otro dispositivo automatizado para acceder al Sitio web o al Servicio; o (ii) 
    eliminar o alterar cualquier autor, marca comercial u otro aviso de propiedad o leyenda que 
    aparezca en el sitio web (o páginas impresas del mismo). El nombre Barri y otros nombres e 
    indicios de propiedad del Servicio son marcas de Barri u otros terceros. Otros productos, 
    servicios y nombres de empresas que aparecen en el sitio web pueden ser marcas comerciales 
    de sus propietarios.</li>
    <br/>
    <li><strong>ENLACES CON OTROS SITIOS:</strong> El sitio web puede contener enlaces a otros sitios y recursos 
    de Internet de la World Wide Web (los "Sitios enlazados"). Los enlaces a cualquier Sitio 
    vinculado no constituyen un endoso o asociación con Barri o cualquiera de sus afiliados. Los 
    enlaces no implican que Barri esté asociado o legalmente autorizado para usar ninguna marca 
    comercial, nombre comercial, logotipo o símbolo de autor que se muestre en los enlaces ni que 
    pueda acceder a ellos, o que los Sitios enlazados estén autorizados para usar cualquier marca 
    comercial, nombre comercial, logotipo o autor, símbolo de Barri o cualquiera de sus afiliados. 
    Debe dirigir cualquier inquietud con respecto a cualquier Sitio vinculado al administrador del sitio 
    o al webmaster de dicho Sitio vinculado. Barri no representa ni respalda la exactitud o 
    confiabilidad de, y renuncia expresamente, a cualquier consejo, opinión, declaración u otra 
    información mostrada o distribuida a través de cualquier Sitio Vinculado. USTED acepta que la 
    confianza en cualquier opinión, consejo o información mostrada o disponible de otro modo a 
    través de un Sitio vinculado será bajo su propio riesgo.
    </li>
    <br/>
    <li><strong>VERIFICACIÓN DE LA IDENTIDAD:</strong> Usted reconoce que su operador de telefonía celular puede 
    compartir los detalles de su suscriptor móvil con Barri para la verificación de identidad. Esos 
    detalles pueden incluir nombre, dirección de facturación, correo electrónico y número de 
    teléfono.
    </li>
  </ol>
  <p>
    <span style="margin-left:3.00em">11.<strong> PRIVACIDAD:</strong> Podemos recopilar y divulgar información personal a terceros como se explica en 
    nuestra Declaración de privacidad. Para obtener una copia, visite <a href="http://www.barri.com">www.barri.com</a> o llame al 1-800-
    926-2277. Recopilamos información personal, por ejemplo, cuando realiza transacciones con 
    nosotros y otras compañías; enviar información sobre solicitudes, formularios y por otros medios; 
    utilizar o visitar nuestra u otras aplicaciones o sitios en línea; ingresar una promoción; registrarse para 
    comunicaciones; o unirse a un programa de lealtad. También recopilamos información de muchas 
    fuentes y podemos recopilar, rastrear y combinar información en dispositivos, plataformas y canales. 
    La información divulgada puede incluir datos financieros (por ejemplo, información sobre 
    transacciones con nosotros y otros asuntos financieros), información de contacto, identificación, 
    computadora, dispositivo móvil e información de redes sociales. Los destinatarios pueden incluir 
    compañías financieras y no financieras, proveedores de servicios, agencias gubernamentales y 
    vendedores directos. Puede indicarnos que limitemos ciertas divulgaciones, y su elección se aplicará 
    hasta que cambie su opción o borremos sus datos. Para limitar las divulgaciones (exclusión 
    voluntaria), llame al 1-800-926-2277.
    </span>
  </p>
  <p>
    <span style="margin-left:3.00em">12.<strong> GENERAL:</strong> Este Acuerdo, junto con todos los elementos incorporados por referencia, incorpora 
    todo el entendimiento entre las partes. Reemplaza todos los acuerdos anteriores y no puede 
    modificarse oralmente. Sujeto a la ley aplicable, Barri puede ceder este Acuerdo a un tercero sin su 
    consentimiento. Este Acuerdo se rige por la ley de Texas sin tener en cuenta las normas sobre 
    conflictos de leyes. Si una disposición del Acuerdo se considera inválida, las disposiciones restantes 
    serán válidas. Los servicios están dirigidos únicamente a personas mayores de 18 años. La versión 
    en idioma inglés controla si hay una incoherencia entre las versiones de Acuerdo en inglés y las que no lo son. Usted y el Beneficiario declaran que su uso de los Servicios no infringe este Acuerdo ni 
    ninguna ley, incluidas, sin límite, las leyes relacionadas con el lavado de dinero, las actividades de 
    juego ilegal, el apoyo a actividades terroristas o el fraude. La información que proporcione Barri 
    deberá ser veraz y completa. Deberá indemnizar a Barri y sus Agentes por todas las pérdidas de 
    cualquier tipo (incluidos los honorarios de los abogados) que surjan de cualquier incumplimiento del 
    Acuerdo por usted o el Beneficiario. Barri se reserva el derecho de cambiar los Servicios sin previo 
    aviso. Barri y sus Agentes pueden negarse a proporcionar Servicios a cualquier persona.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">13.<strong> ALERTA DE FRAUDE AL CONSUMIDOR: PROTÉJASE. TENGA CUIDADO CUANDO UN 
    EXTRAÑO LE PIDA QUE ENVÍE DINERO, ESPECIALMENTE PARA SUBASTAS EN INTERNET, 
    PERIÓDICOS O OFERTAS TELEFÓNICAS.</strong>  Barri no garantiza la entrega o idoneidad de los bienes 
    o servicios pagados con los Servicios. Barri no es un proveedor de servicios de depósito en garantía. 
    Usted y el Destinatario acuerdan no utilizar los Servicios con fines de depósito en garantía.
    </span>
  <p/>

  
  <p>
    <span style="margin-left:3.00em"><strong>Marzo 2021</strong>
    </span>
  <p/>


  `
  
// </body>

// </html> 
module.exports = termsES


// WEBPACK FOOTER //
// ./public/documents/Terms-and-Conditions-sp.js